import reject from 'lodash-es/reject'
import cloneDeep from 'lodash-es/cloneDeep.js'
import apiService from "@/state/services/Api";

const state = {
  visible: false,
  tasks: [],
  pendingTasks: -1,
}

const getters = {
  visible(state) {
    return state.visible
  },
  tasks(state) {
    return state.tasks
  },
  tasksAmount(state) {
    return state.tasks.length
  },
  getPendingTasks(state) {
    return state.pendingTasks
  },
  getTaskById: (state) => (id) => {
    return cloneDeep(state.tasks.find(e => e.id === id))
  },
  getNewTask() {
    return {
      title: '',
      status: '',
      report: {
        file: null,
        fileName: null,
        text: null
      }
    }
  }
}

const mutations = {
  SET_VISIBILITY(state, visible) {
    state.visible = visible
  },

  ADD_TASK(state, task) {
    state.tasks.push({...task})
  },

  UPDATE_TASK_TITLE(state, {id, title}) {
    const task = state.tasks.find(t => t.id === id)
    task.title = title
  },

  UPDATE_TASK_STATUS(state, {id, status}) {
    const task = state.tasks.find(t => t.id === id)
    task.status = status
  },

  REMOVE_TASK(state, id) {
    state.tasks = reject(state.tasks, ['id', id])
  },

  CLEAR_COMPLETED_TASKS(state) {
    state.tasks = state.tasks.filter(t => t.status === 'pending')
  },

  UPDATE_PENDING_TASKS(state, tasksNumber) {
    state.pendingTasks = tasksNumber
  },

  UPDATE_TASK_REPORT(state, {id, report}) {
    const task = state.tasks.find(t => t.id === id)
    task.report = report;
  }
}

const actions = {
  setVisibility({commit}, visible) {
    commit('SET_VISIBILITY', visible)
  },

  addTask({commit}, task) {
    if (!task) {
      return
    }
    task.id = generateTaskId()
    commit('ADD_TASK', task)
    commit('SET_VISIBILITY', true)
    return task.id
  },

  pendingTasksAmount({commit}, taskList) {
    let completedTasks = taskList.filter(t => t.status !== 'pending').length
    let pendingTasks = taskList.length - completedTasks
    commit('UPDATE_PENDING_TASKS', pendingTasks)
  },

  /**
   * @param commit
   * @param payload Contain id (task id) and title
   */
  updateTaskTitle({commit}, payload) {
    if (!payload.id) {
      return
    }
    commit('UPDATE_TASK_TITLE', payload)
  },

  /**
   * @param commit
   * @param payload Contain id (task id) and status
   *                Supported statuses are pending, complete, failed
   */
  updateTaskStatus({commit}, payload) {
    if (!payload.id) {
      return
    }
    commit('UPDATE_TASK_STATUS', payload)
  },

  /**
   * @param commit
   * @param payload
   * @example
   * Payload
   * {
   *   id: '',
   *   report: {
   *     file: 'content of file',
   *     fileName: 'file name',
   *     text: 'text to display to user in-line'
   *   }
   * }
   */
  updateTaskReport({commit}, payload) {
    if (!payload.id) {
      return
    }
    commit('UPDATE_TASK_REPORT', payload)
  },

  removeTask({commit}, id) {
    if (!id) {
      return
    }
    commit('REMOVE_TASK', id)
  },

  clearCompletedTasks({commit}) {
    commit('CLEAR_COMPLETED_TASKS')
  },

  async pollAsyncTaskStatus(context, taskId) {
    return apiService
      .get('readouts/result/', { params: { task_id: taskId } })
      .then(data => { return data });
  }
}

function generateTaskId() {
  return Math.floor(Math.random() * 100000)
}

export default {namespaced: true, state, getters, mutations, actions}
